// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const HealthHealthGet200 = zod.record(zod.string(), zod.string())

export type HealthHealthGet200 = zod.input<typeof HealthHealthGet200>;
export type HealthHealthGet200Output = zod.output<typeof HealthHealthGet200>;
